import { Component, OnInit, Input, Optional, Self, EventEmitter, Output, ViewChildren, QueryList, ElementRef, SimpleChanges, OnChanges, AfterViewInit } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import * as uuid from 'uuid';

@Component({
    selector: 'app-form-selection-list',
    templateUrl: './selection-list.component.html',
    styleUrls: ['./selection-list.component.scss'],
})
export class SelectionListComponent implements OnInit, ControlValueAccessor, OnChanges, AfterViewInit {
    public onChange: (x?: any) => void;

    public onTouched: (x?: any) => void;

    public id: string;

    public _value: any = '';

    @ViewChildren('listInput')
    private listInputs: QueryList<ElementRef>;

    // If true, will automatically select the first value if there is only one present
    @Input() initSelected: boolean;

    @Input() disabled: boolean;

    @Input() data: {
        label: string;
        value: any;
    }[];

    @Output('change') changeOutput = new EventEmitter<any>();

    constructor(@Self() @Optional() private ngControl: NgControl) {
        if (this.ngControl) {
            this.ngControl.valueAccessor = this;
        }
    }

    ngOnInit(): void {
        this.id = uuid.v4();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes?.initSelected?.currentValue && !!changes?.data?.currentValue && changes?.data?.currentValue?.length === 1) {
            this.writeValue(changes.data.currentValue[0].value);
        }
    }

    ngAfterViewInit(): void {
        if (this.initSelected && this.listInputs?.length === 1) {
            this.listInputs.first.nativeElement.checked = true;
        }
    }

    get value(): any {
        return this._value;
    }

    set value(v) {
        this._value = v;
        if (this.onChange) {
            this.changeOutput.emit(v);
            this.onChange(v);
            this.onTouched();
        }
    }

    change(v): void {
        this.value = v;
    }

    writeValue(value: any): void {
        this.value = value;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    registerOnChange(fn: any): void {
        // Store the provided function as an internal method.
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        // Store the provided function as an internal method.
        this.onTouched = fn;
    }
}
